// extracted by mini-css-extract-plugin
export default {"hiddenIFrame":"CookieChecker_hiddenIFrame__CNiZ2"};